module.exports = __webpack_public_path__ + "static/img/IMG_20150910_224742.acbd549d.jpg";